import React, { useEffect, useState } from 'react';
import { useLocation, Routes, Route, Navigate } from 'react-router-dom';

import './ImageManagement.css';
import UploadMedia from './UploadMedia/UploadMedia';
import ListMedia from './ListMedia/ListMedia';
import DeleteMedia from './DeleteMedia/DeleteMedia';
import AssignCategory from './AssignCategory/AssignCategory';
import ImageViewer from './ImageViewer/ImageViewer'; // Import ImageViewer
import Notification from '../Notification/Notification';

const apiUrl = process.env.REACT_APP_API_URL;

function ImageManagement() {
  const location = useLocation();
  const [notification, setNotification] = useState({ message: '', type: '' });
  const [categories, setCategories] = useState([]);
  const [mediaData, setMediaData] = useState([]); // State to hold media data for ImageViewer
  const [token] = useState(localStorage.getItem('token') || '');

  const fetchCategories = async () => {
    try {
      const response = await fetch(`${apiUrl}/categories`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const fetchMediaData = async () => {
    try {
      const response = await fetch(`${apiUrl}/media`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      setMediaData(data);
    } catch (error) {
      console.error('Error fetching media data:', error);
    }
  };

  useEffect(() => {
    if (location.state && location.state.message) {
      setNotification({
        message: location.state.message,
        type: location.state.type,
      });
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  useEffect(() => {
    fetchCategories();
    fetchMediaData();
  }, [token]);

  const handleMediaUpdated = () => {
    fetchMediaData(); // Refresh media data when an update occurs (e.g., rotation stored)
  };

  return (
    <div>
      <h1>Image Management</h1>
      <Routes>
        <Route path="/" element={<Navigate to="list" />} />
        <Route path="list" element={<ListMedia categories={categories} onMediaUpdated={handleMediaUpdated} />} />
        <Route path="upload" element={<UploadMedia />} />
        <Route path="delete" element={<DeleteMedia categories={categories} />} />
        <Route path="assign" element={<AssignCategory categories={categories} />} />
        <Route path="view/:id" element={<ImageViewer categories={categories} data={mediaData} onMediaUpdated={handleMediaUpdated} />} />
      </Routes>
      <Notification
        message={notification.message}
        type={notification.type}
        onClose={() => setNotification({ message: '', type: '' })}
      />
    </div>
  );
}

export default ImageManagement;
